import { Box, VStack } from '@chakra-ui/react'
import { BrandBar } from '../../components/BrandBar'
import { TitleHeader } from '../../components/TitleHeader'
import { CompletionMessage } from './CompletionMessage'
import { PurchaseResult } from './PurchaseResult'
import { AutoRedirectNotice } from './AutoRedirectNotice'
import { ReturnButton } from './ReturnButton'
import { useLogout } from '../../hooks/useLogout'

export const PurchaseSuccessContent = ({ purchasedCoinCount, price, totalCoinCount, onReturnClick, onLogoClick }) => {
  const { logout, isLoading: isLogoutLoading } = useLogout()

  return (
    <Box minH="100vh" bg="background.default" display="flex" justifyContent="center">
      <Box w="100%" maxW="500px">
        <VStack gap={0} align="stretch">
          <BrandBar onLogout={logout} isLogoutLoading={isLogoutLoading} onLogoClick={onLogoClick} />
          <TitleHeader title="決済完了" />
          <Box py="20px" px="16px">
            <VStack gap={6} align="stretch">
              <CompletionMessage />
              <PurchaseResult purchasedCoinCount={purchasedCoinCount} price={price} totalCoinCount={totalCoinCount} />
              <AutoRedirectNotice />
              <ReturnButton onClick={onReturnClick} />
            </VStack>
          </Box>
        </VStack>
      </Box>
    </Box>
  )
}
